import { render, staticRenderFns } from "./SaleReportLabaList.vue?vue&type=template&id=d60fc62a&"
import script from "./SaleReportLabaList.vue?vue&type=script&lang=js&"
export * from "./SaleReportLabaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports